export default __webpack_public_path__ + "fonts/open-sans-300.woff2";